<!-- Affichage du tableau des documents lorsque les données sont chargées -->
@if (idDocumentsTableDisplayed === true && !!filteredDocuments) {
    <table class="details-table" matSort (matSortChange)="sort($event)" [matSortActive]="currentSort.active" [matSortDirection]="currentSort.direction">
        <thead>
            <tr>
                @for (column of displayedColumnsDefinitions; track column.propertyCode) {
                    <th [style.width.px]="column.size" [style.max-width.px]="column.size" [class]="column.propertyCode">
                        <app-detail-table-header-cell
                            [filterHandler]="tableHeaderFilterHandler"
                            [column]="column"
                            [detailTableDataType]="DetailTableDataType.Document"></app-detail-table-header-cell>
                    </th>
                }
            </tr>
        </thead>
        <tbody>
            <!-- Affichage lorsque le tableau est vide -->
            @if (filteredDocuments.length === 0) {
                <tr>
                    <td>Pas de données...</td>
                </tr>
            }
            <!-- Menu contextuel pour pouvoir marquer comme lu/non lu et ajouter l'emetteur aux contacts -->
            <app-detail-table-panel-context-menu
                [ngStyle]="getContextMenuStyle()"
                [contextMenuItems]="contextMenuItems"
                (onContextMenuItemClick)="onContextMenuItemClick($event)"></app-detail-table-panel-context-menu>
            <!-- Affichage lorsque le tableau est rempli -->
            @for (data of filteredDocuments; track data.id) {
                <tr
                    [ngClass]="{ 'is-selected-tr': selectedDocument?.id === data.id, unread: !data.isRead }"
                    (click)="onDocumentSelected(data)"
                    (contextmenu)="$event.preventDefault(); onContextMenuClick($event, data)">
                    @for (column of displayedColumnsDefinitions; track column.propertyCode) {
                        <td
                            class="detail-td"
                            [ngClass]="{ 'cell-icon': column.type === PropertyType.Enum }"
                            [style.width.px]="column.size"
                            [style.max-width.px]="column.size"
                            [class]="column.propertyCode">
                            <app-document-table-cell [column]="column" [data]="data"></app-document-table-cell>
                        </td>
                    }
                </tr>
            }
        </tbody>
        @if (documentSearchText()) {
            <div class="search-display">
                <p>Texte Recherché : {{ documentSearchText() }}</p>
                <fa-icon [icon]="faEraser" class="ereaser-button" (click)="resetFilter()"></fa-icon>
            </div>
        }
        <ngx-spinner name="documents-spinner" [fullScreen]="false" type="timer" size="medium"></ngx-spinner>
    </table>
}

<!-- Affichage du tableau des brouillons de mail lorsque les données sont chargées -->
@if (idDocumentsTableDisplayed === false && !!filteredDrafts) {
    <table class="details-table drafts-email-table">
        <thead>
            <tr>
                <th class="date">
                    <span>Date</span>
                </th>
                <th class="recipient">
                    <span>Destinataire</span>
                </th>
                <th class="subject">
                    <span>Sujet</span>
                </th>
            </tr>
        </thead>
        <tbody>
            <!-- Affichage lorsque le tableau est vide -->
            @if (filteredDrafts.length === 0) {
                <tr>
                    <td>Pas de brouillons...</td>
                </tr>
            }
            <!-- Affichage lorsque le tableau est rempli -->
            @for (data of filteredDrafts; track data.id) {
                <tr (click)="onDraftSelected(data)">
                    <td class="detail-td date">
                        <span [title]="data.creationDate">{{ data.creationDate | date: FRENCH_DATETIME_FORMAT }}</span>
                    </td>
                    <td class="detail-td recipient">
                        <span [title]="data.to">{{ data.to }}</span>
                    </td>
                    <td class="detail-td subject">
                        <span [title]="data.subject">{{ data.subject }}</span>
                    </td>
                </tr>
            }
        </tbody>
        @if (draftEmailSearchText() !== '') {
            <div class="search-display">
                <p>Texte Recherché "{{ draftEmailSearchText() }}"</p>
                <fa-icon [icon]="faEraser" class="ereaser-button" (click)="resetFilter()"></fa-icon>
            </div>
        }
        <ngx-spinner name="drafts-spinner" [fullScreen]="false" type="timer" size="medium"></ngx-spinner>
    </table>
}
